import { Thumbmark } from "@thumbmarkjs/thumbmarkjs";

let pending = null;
let cachedRaw = null;
let cachedHash = null;
let cachedInfo = null;

const tm = new Thumbmark({
  timeout: 1500,
  logging: false,
});

async function sha256Hex(input) {
  const buf = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

// Минимальный device snapshot для X-Device-Info:
// timezone + browser + platform. Кодируем base64(utf8(JSON))
// — header value по RFC 7230 должен быть ASCII-only.
function buildInfo(components) {
  if (!components) return "";
  const sys = components.system || {};
  const compact = {
    timezone: components.timezone || null,
    browser: sys.browser || null,
    platform: sys.platform || null,
  };
  try {
    return btoa(unescape(encodeURIComponent(JSON.stringify(compact))));
  } catch {
    return "";
  }
}

export async function getDeviceFingerprint() {
  if (cachedRaw) {
    return { raw: cachedRaw, hash: cachedHash, info: cachedInfo };
  }
  if (pending) return pending;

  pending = (async () => {
    try {
      const res = await tm.get();
      const raw = res?.thumbmark || "";
      if (!raw) throw new Error("THUMBMARK_EMPTY");
      const hash = await sha256Hex(raw);
      const info = buildInfo(res?.components);
      cachedRaw = raw;
      cachedHash = hash;
      cachedInfo = info;
      return { raw, hash, info };
    } finally {
      pending = null;
    }
  })();

  return pending;
}

export async function getStableDeviceId() {
  const { hash } = await getDeviceFingerprint();
  return hash;
}
